<script>
export default {
    props: [
        'row',
        'column',
        'dropdowns'
    ],
    methods: {
        getPacingBadge(createElement, pacing, shouldPace) {
          if (pacing < shouldPace - 0.02) {
              return createElement(
                  'span', {
                    class: 'badge',
                    style: { background: 'red' }
                  }, 	"under"
              )
          }
          if (pacing > shouldPace + 0.02 ) {
            return createElement(
                'span', {
                  class: 'badge',
                  style: { background: 'blue' }
                }, 	"over"
            )
          }
          return createElement(
              'span', {
                class: 'badge',
                style: { background: 'green' }
              }, 	"on pace"
          )
        },
        getJaPerformanceBadge(createElement, value) {
            if (value == 'top-20-pct') {
                return createElement(
                    'span', {
                        class: 'badge',
                        style: {background: 'green'}
                    }, "Top 20%"
                )
            }
            if (value == 'bottom-20-pct') {
                return createElement(
                    'span', {
                        class: 'badge',
                        style: {background: 'red'}
                    }, "Bottom 20%"
                )
            }
            if (value == 'average') {
                return createElement(
                    'span', {
                        class: 'badge',
                        style: {background: 'white', color: '#333', 'font-weight': 'normal'}
                    }, "Average"
                )
            }
            return null;
        },
        change(createElement, value, formatMethod) {
            return value !== null
                ? createElement('td', {
                    class: 'alr',
                    style: value < 0 ? 'color: #c5221f' : 'color: #188038'
                },[
                    createElement('i', {
                        class: value < 0 ? 'fas fa-arrow-down' : 'fas fa-arrow-up',
                        style: 'float: left'
                    }),
                    formatMethod(value)
                ])
                : createElement('td');
        }
    },
    render(createElement) {
        if (!this.column.type)
            return createElement(
                'td', this.row[this.column.id]
            );

        if (this.column.type === 'employer_link')
            return createElement(
                'td', [
                    createElement(
                    'a', {
                        attrs: {
                            href: this.url(`admin/employer/${this.row['employer_id']}/budgets`)
                        }
                    }, this.row['employer_name']
                ), ..._.map(_.filter(_.split(this.row['employer_tags'], ',')), (color) => {
                        return createElement(
                            'span', {
                                class: 'rbadge',
                                style: { background: this.dropdowns.colors[color].color }
                            }, 	"\u00A0"
                        );
                    })
            ]);

        if (this.column.type === 'employer_notes') {
            let self = this;
            return createElement(
                'td', { 
                    class: 'flex-row'
                }, [
                    createElement(
                        'el-popover', { 
                            props: {
                                placement: 'top-start',
                                trigger: 'hover',
                                width: '400'
                            }
                        }, [
                            createElement(
                                'div', { 
                                    class: 'truncate',
                                    style: { 'max-width': '20rem' },
                                    slot: 'reference'
                                }, self.row[self.column.id]
                            ),
                            self.row[self.column.id]
                        ]
                    ), 
                    createElement(
                        'i', { 
                            class: 'fas fa-edit icon-right',
                            attrs: {
                                'data-employer-id': this.row['employer_id'],
                                title: this.row['employer_name'] + ' Notes'
                            },
                            on: {
                                click: function (event) {
                                    self.$emit('openEmployerNotes', $(event.target).data('employer-id'));
                                }
                            }
                        }
                    ), 
                ]);
        }

        if (this.column.type === 'money')
            return createElement(
                'td', {
                    class: 'alr'
                }, this.money(this.row[this.column.id])
            );

        if (this.column.type === 'number')
            return createElement(
                'td', {
                    class: 'alr'
                }, this.usNum(this.row[this.column.id])
            );

        if (this.column.type === 'percentage')
            return createElement(
                'td', {
                    class: 'alr'
                }, this.percent(this.row[this.column.id])
            );

        if (this.column.type === 'right')
            return createElement(
                'td', {
                    class: 'alr'
                }, this.row[this.column.id]
            );

        if (this.column.type === 'tags')
            return createElement(
                'td', _.map(_.split(this.row[this.column.id], ','), (color) => {
                    return createElement(
                        'span', {
                            class: 'badge',
                            style: { background: this.dropdowns.colors[color].color }
                        }, 	"\u00A0"
                    );
                })
            );

        if (this.column.type === 'pacing')
            return createElement(
                'td', {
                        class: 'alr'
                    }, this.row[this.column.id] >= 0.01
                    ? [ this.percent(this.row[this.column.id]), ' ',
                        createElement('span', {
                                class: 'pcwrapper'
                            }, [this.getPacingBadge(createElement, this.row[this.column.id], this.row['should_pace_at'])]
                        )]
                    : [ '' ]
        );

        if (this.column.type === 'change')
            return this.change(createElement, this.row[this.column.id], this.usNum);
        if (this.column.type === 'changeMoney')
            return this.change(createElement, this.row[this.column.id], this.money);
        if (this.column.type === 'changePercent')
            return this.change(createElement, this.row[this.column.id], this.percent);

        if (this.column.type === 'jaPerformance') {
            return createElement(
                'td', {
                    class: 'alr'
                }, [
                    this.getJaPerformanceBadge(createElement, this.row[this.column.id])
                ]
            );
        }

        if (this.column.type === 'fulfillment')
            return this.row['ff_id']
                    ? createElement(
                            'td', {
                                class: 'alr'
                            }, [
                                createElement(
                                    'a', {
                                        attrs: {
                                            href: this.url(`admin/driver-engage/fulfillment/${this.row['ff_id']}`)
                                        }
                                    }, `${this.row['ff_apps_delivered']}/${this.row['ff_apps_ordered']}`
                                )
                            ])
                    : createElement('td');

        if (this.column.type === 'appsvgoal')
            return createElement(
                'td', {
                    class: 'alr'
                }, this.row[this.column.cols[1]] > 0 ? `${this.row[this.column.cols[0]]}/${this.row[this.column.cols[1]]}` : ''
            );

        return createElement(
            'td', ''
        );
    }
}
</script>
